import { render, staticRenderFns } from "./VSearch.vue?vue&type=template&id=3207da38&scoped=true&"
import script from "./VSearch.vue?vue&type=script&lang=js&"
export * from "./VSearch.vue?vue&type=script&lang=js&"
import style0 from "./VSearch.vue?vue&type=style&index=0&id=3207da38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3207da38",
  null
  
)

export default component.exports